module.exports = __webpack_public_path__ + "img/8.4ab53e35.png";